<script setup lang="ts">
import { inject, ref, unref, toRefs, watch, watchEffect } from 'vue';
import ViewOverlayGrid2 from '@/src/components/ViewOverlayGrid2.vue';
import { useSliceConfig } from '@/src/composables/useSliceConfig';
import { useDynSliceController } from '@/src/composables/useDynSliceController';
import { Maybe } from '@/src/types';
import { VtkViewContext } from '@/src/components/vtk/context';
import { useWindowingConfig } from '@/src/composables/useWindowingConfig';
import { useOrientationLabels } from '@/src/composables/useOrientationLabels';
import DicomQuickInfoButton from '@/src/components/DicomQuickInfoButton.vue';

interface Props {
  viewId: string;
  imageId: Maybe<string>;
  }

const props = defineProps<Props>();
const { viewId, imageId } = toRefs(props);

const { slice: currentSlice, range: sliceRange } = useSliceConfig(
  viewId,
  imageId
);

const {startScrolling, stopScolling, setLoopingParam, setSliceParam} = useDynSliceController(viewId, imageId);

const looping = ref(true);
watchEffect(() => {
  setLoopingParam(looping.value);
});

const step = ref(0);
watch(step, (v) => {
  console.log("step updated", v)
  if(v != currentSlice.value+1) {
    currentSlice.value = v-1;
    console.log("we change currentSlice", currentSlice.value)
    setSliceParam(currentSlice.value);
  }
});

watch(currentSlice, (v) => {
  console.log("watch currentSlice update", v)
  if(v != step.value-1) {
    step.value = v+1;
    setSliceParam(v)
  }
});
</script>


<template>
  <view-overlay-grid2 class="overlay-footer">

    <template v-slot:middle>
        <div class="barItem">
          <v-btn color="rgb(var(--v-theme-surface))" @click="startScrolling(looping)">Start</v-btn>
        </div>
        <div class="barItem">
          <v-btn color="rgb(var(--v-theme-surface))" @click="stopScolling">Stop</v-btn>
          <v-checkbox v-model="looping" label="looping" :style="{ color: 'black' }" hide-details />
        </div>
        <div class="barItem">
          <v-slider class="slider-container" v-model="step" :min="1" :max="90" :step="1" label="coucou" hide-details />
        </div>
    </template>
 </view-overlay-grid2>
</template>

<style scoped src="@/src/components/styles/vtk-view.css"></style>
<style >
.barItem {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.slider-container {
  color: black;
/*  display: block;*/
  flex-grow: 1;         /* Allow the slider to stretch horizontally */
  min-width: 200px;     /* Ensure it doesn't get too small (optional) */
}

.v-slider {
  width: 100%;          /* Force the slider itself to expand */
}
</style>
